import './index.scss';

import App from './App';
import IntlProvider from './languages';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { store, persistor } from './redux/store';
import reportWebVitals from './reportWebVitals';
import LogRocket from 'logrocket';

LogRocket.init('bdltfv/mk');
ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <IntlProvider>
        <App />
      </IntlProvider>
    </PersistGate>
  </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
